/**
 * Shared dependencies
 */
import type { StoreFunctions } from '../../shared/types/store';
import type { WP_Recipe } from '../../shared/types/recipe';

/**
 * Internal dependencies
 */
import { getRecipes, type GetRecipesParams } from '../requests';

/**
 * Fetches user lists and updates the store with recipes by their IDs.
 * Also dispatches a ListEvent to notify other parts of the app.
 *
 * @param fn - Function to update the store state.
 * @return Promise that resolves to an array of user lists.
 */
export async function recipesGetByArrayOfIds(
	fn: StoreFunctions,
	params: GetRecipesParams
): Promise<WP_Recipe[]> {
	const {
		events: { RecipeEvent },
	} = window.valioApp;

	const recipes = await getRecipes(params);

	// Convert array to Record structure keyed by recipe ID
	const recipesRecord = recipes.reduce(
		(acc, recipe) => {
			acc[recipe.id] = recipe;
			return acc;
		},
		{} as Record<string, WP_Recipe>
	);

	fn.set({
		data: {
			...fn.get().data,
			recipes: recipesRecord,
		},
	});

	// Dispatch the event to notify other parts of the app
	RecipeEvent.fetch({ data: recipesRecord });

	// Return the fetched recipes
	return recipes;
}
